import { createSelector, createSlice } from '@reduxjs/toolkit';

import { ProductModel } from '@/models';
import { ForCarouselPayload, SlicePayload, UntypedObject } from '@/types';
import { RootState } from '@/redux/create-store';

export type ProductState = {
  id?: string;
  content: UntypedObject;
  carouselProducts: ProductModel[];
  addProductToCartModalVisible: boolean;
  productAddedToCart: ProductModel;
}

export const initialState: ProductState = {
  id: undefined,
  content: {},
  carouselProducts: [],
  addProductToCartModalVisible: false,
  productAddedToCart: undefined
};

const product = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getProduct: (_state, _action: SlicePayload<{ id: string }>) => {
    },

    getProductSuccess: (state, action: SlicePayload<{ id: string, product: UntypedObject }>) => {
      const { id, product } = action.payload;
      state.content = product;
      state.id = id;
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getExclusiveCellarProduct: (_state) => {
    },

    redirectBoxPage: (
      _state,
      _action: SlicePayload<{
        inStockId: string, item: UntypedObject, qty: number, options?: UntypedObject, millesime?: string
      }>
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ) => {
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getProductsForCarousel: (_state, _action: SlicePayload<ForCarouselPayload>) => {},

    getCarouselProductsSuccess: (state, action: SlicePayload<ProductModel[]>) => {
      state.carouselProducts = action.payload;
    },

    toggleAddToCartModal: (
      state,
      action: SlicePayload<{ opened: boolean, product?: ProductModel }>
    ) => {
      state.addProductToCartModalVisible = action.payload.opened;
      state.productAddedToCart = action.payload.product;
    }
  }
});

export const {
  getProduct, getProductSuccess,
  getExclusiveCellarProduct,
  redirectBoxPage, getProductsForCarousel, getCarouselProductsSuccess,
  toggleAddToCartModal
} = product.actions;

export default product.reducer;

const selectProductState = (state: RootState) => state.product;

export const selectAddToCartModalInfos = createSelector(
  [selectProductState],
  (product) => ({
    productToAdd: product.productAddedToCart,
    addToCartModalVisible: product.addProductToCartModalVisible
  })
);
